import { S_LANG, S_MARKET, webStorage } from "../utils/webStorage";
import api from "../utils/api";
import store from "../redux/store/store";
import { addressTypes, InstantCode, PickupInStoreCode } from "../utils/lynkco-constants";
import { getMarketCountry } from "./siteService";
import { selectUserState } from "../selectors/application";
import { getDeliveryMethods } from "./orderService";
import { MathUtils } from "../utils";

export const buildAddress = (type, source, contactFormData, diffAddr) => {
  const result = Object.create(null);
  const phoneAreaCode = contactFormData.phoneArea ? contactFormData.phoneArea : "";
  const phone = contactFormData.phone;
  const market = webStorage.get(S_MARKET);
  result[type + "Address1"] = source.street;
  result[type + "Address2"] = source.apartment;
  result[type + "City"] = source.city;
  result[type + "FirstName"] = source.firstName;
  result[type + "LastName"] = source.lastName;
  result[type + "PostalCode"] = source.postalCode;
  result[type + "Email"] = contactFormData.email;
  if (type === "receiver") {
    result[type + "MobileCountryCode"] = phoneAreaCode;
    result[type + "Mobile"] = phone;
    result[type + "CountryCode"] = market.countryCode;
    result[type + "Country"] = market.countryName;
  }
  if (type === "billing") {
    result[type + "PhoneCountryCode"] = phoneAreaCode;
    result[type + "Phone"] = phone;
    if (!diffAddr) {
      result[type + "CountryCode"] = market.countryCode;
      result[type + "Country"] = market.countryName;
    } else {
      result[type + "CountryCode"] = source.countryCode;
      result[type + "Country"] = source.country;
    }
  }
  return result;
};
export const buildBillingAddr = (source, contactFormData, diffAddr) => {
  return buildAddress("billing", source, contactFormData, diffAddr);
};
export const getAddressList = async newAddressLabel => {
  let { obj } = await api.address.list();
  const state = store.getState();
  const user = selectUserState(state);
  let _addressList = (obj || []).map(address => {
    return {
      address: {
        ...address,
        firstName: user.firstName,
        lastName: user.lastName
      },
      value: address.addressId
    };
  });
  if (_addressList.length > 0) {
    _addressList.push({ label: newAddressLabel, value: "new" });
  }
  return _addressList;
};
export const saveCheckoutAddress = async (diffAddr, shippingFormData, billingFormData) => {
  const state = store.getState();
  const user = selectUserState(state);
  try {
    const country = await getMarketCountry();
    if (shippingFormData.unSave) {
      await api.address.create(null, {
        firstName: user?.firstName,
        lastName: user?.lastName,
        mobile: shippingFormData.phone,
        mobileCountryCode: shippingFormData.phoneArea,
        countryId: country.regionId.toString(),
        countryCode: country.regionAbbr,
        country: country.regionName,
        city: shippingFormData.city,
        street: shippingFormData.street,
        apartment: shippingFormData.apartment,
        postalCode: shippingFormData.postalCode,
        defaultFlag: "0",
        addressType: addressTypes.shipping
      });
    }
    if (diffAddr && billingFormData.unSave) {
      await api.address.create(null, {
        firstName: user?.firstName,
        lastName: user?.lastName,
        mobile: billingFormData.phone,
        mobileCountryCode: billingFormData.phoneArea,
        countryId: billingFormData.countryId,
        countryCode: billingFormData.countryCode,
        country: billingFormData.country,
        city: billingFormData.city,
        street: billingFormData.street,
        apartment: billingFormData.apartment,
        postalCode: billingFormData.postalCode,
        defaultFlag: "0",
        addressType: addressTypes.shipping
      });
    }
  } catch (ex) {
    console.log("ex", ex);
  }
};
export const savePreSalesAddress = async billingFormData => {
  const state = store.getState();
  const user = selectUserState(state);
  try {
    if (billingFormData.unSave) {
      await api.address.create(null, {
        firstName: user?.firstName,
        lastName: user?.lastName,
        mobile: billingFormData.phone,
        mobileCountryCode: billingFormData.phoneArea,
        countryId: billingFormData.countryId,
        countryCode: billingFormData.countryCode,
        country: billingFormData.country,
        city: billingFormData.city,
        street: billingFormData.street,
        apartment: billingFormData.apartment,
        postalCode: billingFormData.postalCode,
        defaultFlag: "0",
        addressType: addressTypes.shipping
      });
    }
  } catch (ex) {
    console.log("ex", ex);
  }
};
export const initDeliveryMethods = async (cartSpuIds, isInStore) => {
  const lang = webStorage.get(S_LANG);
  const methods = await getDeliveryMethods(cartSpuIds);
  let deliveryMethods = methods.reduce((result, e) => {
    const { name, deliveryMethodId, deliveryMethodCode, path, estimateDeliveryTime, cost, description } = e;
    if ((isInStore && deliveryMethodCode !== PickupInStoreCode) || (!isInStore && deliveryMethodCode !== InstantCode)) {
      result.push({
        label: name,
        value: deliveryMethodId.toString(),
        code: deliveryMethodCode,
        logo: path,
        deliveryTime: estimateDeliveryTime,
        formattedPrice: MathUtils.priceFormat(cost, lang),
        note: description
      });
    }
    return result;
  }, []);
  return deliveryMethods;
};
